import React from 'react';
import ToggleList from '../wizardToolGlobalGenericEmissionsConversionComponents/ToggleList.js';

class WizardItemGlobalGenericEmissionsConversion extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="global-generic-emissions-conversion-wrapper">
				<ToggleList togglegroup={this.props.data.ToggleGroup} />
			</div>
		)
	}
}

export default WizardItemGlobalGenericEmissionsConversion;